module.exports = __webpack_public_path__ + "static/media/10UNOHRLLS9.34e64d1d.jpg";